import { ConciergeHubPageView } from '@/lib/pages/concierge';
import { getConciergePageStaticProps } from '@/lib/pages/concierge/get-static-props';

import { getConciergeHubPage } from '@/lib/entities/concierge/server-content';
import { SeoEntries } from '@/lib/entities/seo/lib/seo-entries';

import { InferGetStaticPropsType } from 'next';

const PATH = '/concierge';

export default function ConciergePage({
  page,
  locale,
  pageSeo,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <SeoEntries
        fallback={{
          title: page.metaTitle,
          description: page.metaDescription,
          keywords: 'concierge phuket, villa carte concierge',
          openGraphImage: '/images/og.png',
        }}
        seo={pageSeo}
        language={locale}
        path={PATH}
      />
      <ConciergeHubPageView page={page} locale={locale} h1={pageSeo?.h1} />
    </>
  );
}

export const getStaticProps = getConciergePageStaticProps(
  getConciergeHubPage,
  PATH
);
